import { takeEvery, put, call } from "redux-saga/effects"
import { toast } from "react-toastify";
// Login Redux States
import { ADD_REVIEW_DISTRIBUTION, DELETE_REVIEW_SOURCE, GET_REVIEW_DISTRIBUTION, UPDATE_REVIEW_SOURCE, UPLOAD_TEST_FILE } from "./actionTypes"
import {
  addReviewDistributionError,
  addReviewDistributionSuccess,
  deleteReviewSourceFail,
  deleteReviewSourceSuccess,
  getReviewDistributionFail,
  getReviewDistributionSuccess,
  updateReviewSourceFail,
  updateReviewSourceSuccess,
  uploadTestFIleError,
  uploadTestFIleSuccess,
} from "./actions"

import { deleteReviewSourceAPI, getReviewSourceAPI, postReviewSourceAPI, updateReviewSourceAPI, postTestUploadAPI } from "../../../helpers/backend_helper"

function* submitReviewSources({ payload: { review, history } }) {
  try {
    toast.loading("Please wait...")
      const response = yield call(postReviewSourceAPI, {
            agentId:parseInt(localStorage.getItem('userId')),
            sourceType: 0,
            sourceName: review.sourceName,
            sourceReviewLink: review.sourceReviewLink,
            isActive:true,
      })
        yield put(addReviewDistributionSuccess(response))
        if (response.success == true) {
          toast.dismiss();
          toast.success("Submitted Successfully");
          const response = yield call(getReviewSourceAPI,parseInt(localStorage.getItem('userId')))
        yield put(getReviewDistributionSuccess(response))
        } else {
          toast.warn("Some Error. Please try after some time");
        }
    }
catch (error) {

  yield put(addReviewDistributionError('Some Error'))
}
}

function* fetchReviewSources({agentId}) {
  try {
    const response = yield call(getReviewSourceAPI,agentId)
    yield put(getReviewDistributionSuccess(response))
  } catch (error) {
    yield put(getReviewDistributionFail(error))
  }
}

function* removeReviewSource({ payload }) {
  try {
    toast.loading("Please wait...")
    const id = payload?.id ?? payload?.reviewSourceLinkId
    if (id == null) {
      toast.dismiss()
      toast.warn("Missing review source id")
      yield put(deleteReviewSourceFail(new Error("Missing id")))
      return
    }
    const response = yield call(deleteReviewSourceAPI, id)
    yield put(deleteReviewSourceSuccess(response))
    toast.dismiss()
    toast.success("Deleted successfully")
    const agentId = parseInt(localStorage.getItem("userId"), 10)
    const list = yield call(getReviewSourceAPI, agentId)
    yield put(getReviewDistributionSuccess(list))
  } catch (error) {
    toast.dismiss()
    toast.error("Delete failed")
    yield put(deleteReviewSourceFail(error))
  }
}

function* editReviewSource({ payload }) {
  try {
    toast.loading("Please wait...")
    const id = payload?.id ?? payload?.reviewSourceLinkId
    if (id == null) {
      toast.dismiss()
      toast.warn("Missing review source id")
      yield put(updateReviewSourceFail(new Error("Missing id")))
      return
    }

    const body = {
      id: parseInt(id, 10),
      reviewSourceLinkId: payload.reviewSourceLinkId || id,
      agentId: payload.agentId
        ? parseInt(payload.agentId, 10)
        : parseInt(localStorage.getItem("userId"), 10),
      sourceType: payload.sourceType != null ? payload.sourceType : 0,
      sourceName: payload.sourceName,
      sourceReviewLink: payload.sourceReviewLink,
      isActive: payload.isActive !== undefined ? payload.isActive : true,
    }

    const response = yield call(updateReviewSourceAPI, body)
    yield put(updateReviewSourceSuccess(response))
    toast.dismiss()

    if (response?.success === false) {
      toast.error(response?.message || "Update failed")
      return
    }

    toast.success("Updated successfully")
    const agentId = parseInt(localStorage.getItem("userId"), 10)
    const list = yield call(getReviewSourceAPI, agentId)
    yield put(getReviewDistributionSuccess(list))
  } catch (error) {
    toast.dismiss()
    toast.error(error?.response?.data?.message || error?.message || "Update failed")
    yield put(updateReviewSourceFail(error))
  }
}

function* submitTestUpload({ payload: { data, history } }) {
  try {
    toast.loading("Please wait...")
      const response = yield call(postTestUploadAPI, data)
        yield put(uploadTestFIleSuccess(response))
  
    }
catch (error) {

  yield put(uploadTestFIleError('Some Error'))
}
}
function* reviewDisSaga() {
  yield takeEvery(ADD_REVIEW_DISTRIBUTION, submitReviewSources)
  yield takeEvery(GET_REVIEW_DISTRIBUTION, fetchReviewSources)
  yield takeEvery(DELETE_REVIEW_SOURCE, removeReviewSource)
  yield takeEvery(UPDATE_REVIEW_SOURCE, editReviewSource)
  yield takeEvery(UPLOAD_TEST_FILE, submitTestUpload)
}

export default reviewDisSaga
